import { render, staticRenderFns } from "./knowledge-goods.vue?vue&type=template&id=4a588a2e&scoped=true&"
import script from "./knowledge-goods.vue?vue&type=script&lang=js&"
export * from "./knowledge-goods.vue?vue&type=script&lang=js&"
import style0 from "./knowledge-goods.vue?vue&type=style&index=0&id=4a588a2e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a588a2e",
  null
  
)

export default component.exports